<template>
    <div>
        <table class="body-2 text-center mt-5">
            <tr>
                <td colspan="7" class="text-h2 noBorder text-left py-0">
                    <div :class="dataObject.getCSSColor(type, 'tabPkt', [
                                'font-weight-bold text-truncate mb-1'])">
                        <span :class="tvModeClass">{{dataObject[type].teamName}}</span>
                    </div>
                </td>
            </tr>
            <tr :class="tvModeClassHeader">
                <td class="text-left pl-2" style="width: 160px">Name</td>
                <td>FW</td>
                <td v-if="isCup" class="text-center px-1"/>
                <td>1.D</td>
                <td>2.D</td>
                <td>3.D</td>
                <td>4.D</td>
                <td v-if="!isCup"><div :class="getDivCSSHeader">Kegel</div><div :class="getDivCSSHeader">SP</div></td>
                <td><span class="ml-1" v-if="!isCup">MP</span><span v-else >Kegel</span></td>
            </tr>
            <tr v-for="i in numberOfSpieler" :key="i" :class="tvModeClass">
                <td class="spieler text-left pl-2">
                    {{dataObject.partien[i][type].spieler.name.substr(8)}}
                </td>
                <td>
                    {{dataObject.partien[i][type].fehlwuerfe}}
                </td>
                <td v-if="isCup" class="text-center px-2">
                    <div class="mb-4">Volle</div><div>Abr.</div>
                </td>
                <td v-for="j in 4" :key="j" class="pa-0">
                    <div :class="getDgDivTopCSS" >
                        {{dataObject.partien[i][type].input['d'+j]}}
                    </div>
                    <div :class="getDgDivBottomCSS">
                        <span v-if="!isCup">{{dataObject.partien[i][type]['sp'+j]}}</span>
                        <span v-else>{{dataObject.partien[i][type].inputAr['ar'+j]}}</span>
                    </div>
                </td>
                <td v-if="!isCup" class="pa-0 font-weight-bold">
                    <div :class="getSumDivTopCSS">{{dataObject.partien[i][type].kegel}}</div>
                    <div :class="getSumDivBottomCSS">{{dataObject.partien[i][type].sp}}</div>
                <td class="font-weight-bold">
                    <span v-if="!isCup">{{dataObject.partien[i][type].mp}}</span>
                    <span v-else>{{dataObject.partien[i][type].kegel}}</span>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        name: "tv-display-team",
        props: ['dataObject', 'type'],
        computed: {
            isCup(){ return this.dataObject.saison.isCup},
            label(){ return this.type === 'heim' ? 'Heim' : 'Gast'; },
            numberOfSpieler() { return Object.keys(this.dataObject.partien).length; },
            tvModeText(){
                return ['lgTV'];
                /*return [{'smTV': this.$vuetify.breakpoint.smOnly},
                    {'mdTV': this.$vuetify.breakpoint.mdOnly},
                    {'lgTV': this.$vuetify.breakpoint.lgOnly},
                    {'xlTV': this.$vuetify.breakpoint.xlOnly},
                ]*/
            },
            getDivCSSHeader(){
                return [{'py-1': this.$vuetify.breakpoint.smOnly},
                    {'py-1': this.$vuetify.breakpoint.mdOnly},
                    {'py-2': this.$vuetify.breakpoint.lgOnly},
                    {'py-2': this.$vuetify.breakpoint.xlOnly},];
            },
            getDgDivTopCSS(){
                return [{'py-1': this.$vuetify.breakpoint.smOnly},
                    {'py-2': this.$vuetify.breakpoint.mdOnly},
                    {'py-2': this.$vuetify.breakpoint.lgOnly},
                    {'py-2': this.$vuetify.breakpoint.xlOnly},];
            },
            getDgDivBottomCSS(){
                return [{'py-1': this.$vuetify.breakpoint.smOnly},
                    {'py-2': this.$vuetify.breakpoint.mdOnly},
                    {'py-2': this.$vuetify.breakpoint.lgOnly},
                    {'py-2': this.$vuetify.breakpoint.xlOnly},];
            },
            getSumDivTopCSS(){
                return [{'py-1': this.$vuetify.breakpoint.smOnly},
                    {'py-2': this.$vuetify.breakpoint.mdOnly},
                    {'py-2': this.$vuetify.breakpoint.lgOnly},
                    {'py-2': this.$vuetify.breakpoint.xlOnly},];
            },
            getSumDivBottomCSS(){
                return [{'py-1': this.$vuetify.breakpoint.smOnly},
                    {'py-2': this.$vuetify.breakpoint.mdOnly},
                    {'py-2': this.$vuetify.breakpoint.lgOnly},
                    {'py-2': this.$vuetify.breakpoint.xlOnly},];
            },
            tvModeClass(){
                return this.tvModeText;
            },
            tvModeClassHeader(){
                return this.tvModeText.concat(['text-center font-weight-bold grey lighten-4']);
            }
        },
    }
</script>

<style scoped>
    table {width: 100%; border-spacing: 0; table-layout: auto; border-bottom: solid 1px black  }
    td {border: solid 1px black; padding: 2px 10px}
    .noBorder {border: none}
    .spieler {
        padding-top: 4px;
        white-space: nowrap; text-overflow:ellipsis; overflow: hidden;
        width: 100%; max-width: 0;
    }
    .smTV { font-size: 18px; height: 50px  }
    .mdTV { font-size: 24px; height: 66px  }
    .lgTV { font-size: 26px; height: 80px  }
    .xlTV { font-size: 48px; height: 130px }

</style>